// Polis › Following (15 October 2026): the dashboard of the public figures the organisation follows.
export default {
  titre: 'Following',
  sousTitre: 'No one followed · {max} follows available | {n} public figure followed of {max} · listened to every day | {n} public figures followed of {max} · listened to every day',
  chargement: 'Loading follows…',
  periode: { aria: 'Period', jours7: '7 days', jours30: '30 days' },
  suivre: 'Follow a public figure',
  quand: { aujourdhui: 'today', hier: 'yesterday' },
  alertes: {
    titre: 'What moved since yesterday',
    toutLu: 'Mark all as read',
    nouvelle: 'New',
    // The count at the top of a public figure's card (16 October 2026).
    nouvelles: '{n} new | {n} new | {n} new',
    voirFiche: 'View profile',
    autres: 'See the other change | See the other change | See the {n} other changes',
    reduire: 'Collapse',
    calme: 'Nothing moved since yesterday: no alert on your follows.',
  },
  tableau: {
    titre: 'Followed public figures',
    aide: 'score from 0 to 100 based on what is said, 50 being neutral · share of voice among your followed figures',
    personnalite: 'Public figure',
    note: 'Score',
    courbe: '{n} days',
    volume: 'Volume',
    part: 'Share of voice',
    theme: 'What it is about',
    alertes: 'Alerts',
    ecart: '{n} over 7 days',
    fois: '×{v}',
    pct: '{n}%',
    inconnu: '·',
    nouvelles: 'new alert | new alert | new alerts',
    premiere: 'First listening in progress',
    courbeAria: 'The score of {nom} over the period: {note} on the last day',
  },
  courbes: {
    titre: 'Their scores, day by day',
    aide: 'pick a name to bring it forward',
    legende: 'Bring a public figure forward',
    aria: 'The scores of the followed public figures, day by day, over the period',
    aujourdhui: 'today',
  },
  vide: {
    titre: 'No one followed yet',
    texte: 'Following a public figure starts a daily listening: what is said, their own words, every quote with its source, who is talking, their positions topic by topic, and an alert when something moves. Your organisation can follow {max}.',
    annuaire: 'Open the directory',
  },
}
